// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"93649d7f","260":"77c6061b","596":"46635083","725":"bfd42ae4"}[chunkId] + ".chunk.js";
};